import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@readsavor/api-client';
import { userQueryKeys } from './useUser';
/**
 * Hook for user registration.
 * Handles the mutation for signing up a user and invalidates the user query on success.
 */
export const useRegister = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (credentials) => apiClient.auth.register(credentials),
        onSuccess: () => {
            // On successful registration, invalidate the user query to refetch user data,
            // as the backend might automatically sign in the user.
            queryClient.invalidateQueries({ queryKey: userQueryKeys.all });
        },
    });
};
//# sourceMappingURL=useRegister.js.map